module.exports = __webpack_public_path__ + "static/media/plate5-icon1.ba3a920b.png";